import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { BenefitRuleForm } from '@/modules/benefits/components/BenefitRuleForm'
import { useBenefitRuleMutation } from '@/modules/benefits/hooks/useBenefitRuleMutation'

export function BenefitRuleCreatePage() {
  const { create, isSubmitting, error } = useBenefitRuleMutation()

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to="/benefits" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Nueva Regla de Beneficio</h1>
      </div>
      <div className="card p-6">
        <BenefitRuleForm
          onSubmit={create}
          isSubmitting={isSubmitting}
          submitLabel="Crear regla"
          error={error}
        />
      </div>
    </div>
  )
}
